// @flow
import { createGlobalStyle } from "styled-components";
import { bodyBackgroundColor, fontSize, textColor } from "./theme";

const GlobalStyles = createGlobalStyle`
  html, body {
    background: ${bodyBackgroundColor};
    color: ${textColor};
    font-size: ${fontSize};
    transition: all 0.25s linear;
  }
  div:focus {
    outline: none;
  }
`;

export default GlobalStyles;
